module.exports = __webpack_public_path__ + "img/05_tomanto FLIPPED.366a16fa.png";